import { createContext, useContext } from 'react';
import { ITranslationsContext } from './types';

export const TranslationsContext = createContext<ITranslationsContext>({
	bundle: {},
	loading: false,
	error: null,
	refetch: async () => undefined
});

export const useTranslationsContext = (): ITranslationsContext =>
	useContext(TranslationsContext);
